// extracted by mini-css-extract-plugin
module.exports = {"applicationName":"ApplicationName_applicationName__2TEQU"};